import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-skeleton-loader',
  templateUrl: './progress-skeleton-loader.component.html',
  styleUrls: ['./progress-skeleton-loader.component.css']
})
export class ProgressSkeletonLoaderComponent implements OnInit {

  @Input() count:number = 1;

  constructor() { }

  ngOnInit(): void {
  }

  loopCounter = () => {
    return [...Array(this.count).keys()]
  }

}
